import { buildListViewLines, findFieldByName, getFieldsByNameList } from "./ListPageGenertor";

export const calendarViewTemplate = {
    startField: {},
    titleField: {},
    lines: [],
    endField: {},
    showFullCalender: true,
    views: ["M"],
    calendarViewAddlFields:[]
  }

  export function getCalendarView(listFields:any ,  startField: string,
  additionalFields: any):any {

     const calendarView = calendarViewTemplate;
      const listViewLines = buildListViewLines(listFields);
      calendarView.lines = listViewLines;
      calendarView.startField = findFieldByName(listFields, startField);
      calendarView.endField = findFieldByName(listFields, startField);
       calendarView.calendarViewAddlFields = getFieldsByNameList(listFields, additionalFields);

       return calendarView;
  }